export function toSafeInternalPath(value?: string | null, fallback = '/'): string {
  if (!value || !value.startsWith('/')) {
    return fallback;
  }

  if (value[1] === '/' || value[1] === '\\') {
    return fallback;
  }

  return value;
}
